// extracted by mini-css-extract-plugin
module.exports =  {"button":"_33974c2b58--button--RKZvy","icon":"_33974c2b58--icon--M4N1r"};